import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24499 21024"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:271.494}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528320135664">
        <path
          d="M22978 1047H1522c-93 0-168-75-168-168s75-168 168-168h21456c92 0 168 75 168 168s-76 168-168 168z"
          className="fill stroke1"
          style={{
            strokeWidth: 271.494,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M879 472c-224 0-407 183-407 407 0 225 183 408 407 408 225 0 408-183 408-408 0-224-183-407-408-407zm0 1151c-410 0-743-334-743-744s333-743 743-743 744 333 744 743-334 744-744 744zM23620 472c-225 0-407 183-407 407 0 225 182 408 407 408 224 0 407-183 407-408 0-224-183-407-407-407zm0 1151c-410 0-744-334-744-744s334-743 744-743 744 333 744 743-334 744-744 744zM12016 20888H2053V1163c0-93 75-169 168-169s169 76 169 169v19388h9290V879c0-92 75-168 168-168s168 76 168 168v20009zM22446 20888h-9963V1163c0-93 76-169 169-169s168 76 168 169v19388h9290V879c0-92 75-168 168-168s168 76 168 168v20009z"
                    className="fill stroke1"
          style={{
            strokeWidth: 271.494,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M11848 14769H2221c-93 0-168-76-168-168 0-93 75-168 168-168h9627c93 0 168 75 168 168 0 92-75 168-168 168zM22278 9570h-9626c-93 0-169-75-169-168s76-168 169-168h9626c93 0 168 75 168 168s-75 168-168 168z"
                    className="fill stroke1"
          style={{
            strokeWidth: 271.494,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M7035 15245c-93 0-169-75-169-168v-476c0-93 76-168 169-168s168 75 168 168v476c0 93-75 168-168 168z"
                    className="fill stroke1"
          style={{
            strokeWidth: 271.494,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M7035 15412c-284 0-437 121-437 170 0 48 153 169 437 169s436-121 436-169c0-49-152-170-436-170zm0 675c-441 0-774-217-774-505 0-289 333-506 774-506s773 217 773 506c0 288-332 505-773 505zM17465 10225c-93 0-168-76-168-168v-477c0-93 75-168 168-168s168 75 168 168v477c0 92-75 168-168 168z"
                    className="fill stroke1"
          style={{
            strokeWidth: 271.494,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M17465 10392c-284 0-437 120-437 169s153 169 437 169 436-120 436-169-152-169-436-169zm0 675c-441 0-774-218-774-506s333-505 774-505 773 217 773 505-332 506-773 506zM6031 10392H2221c-93 0-168-75-168-168s75-168 168-168h3810c93 0 168 75 168 168s-75 168-168 168zM11848 10392H7640c-93 0-169-75-169-168s76-168 169-168h4208c93 0 168 75 168 168s-75 168-168 168zM8571 6713H2221c-93 0-168-76-168-169 0-92 75-168 168-168h6350c93 0 168 76 168 168 0 93-75 169-168 169zM11848 6713H9921c-93 0-169-76-169-169 0-92 76-168 169-168h1927c93 0 168 76 168 168 0 93-75 169-168 169zM14921 5363h-2269c-93 0-169-75-169-168s76-168 169-168h2269c93 0 168 75 168 168s-75 168-168 168zM18929 5363h-2976c-93 0-168-75-168-168s75-168 168-168h2976c93 0 169 75 169 168s-76 168-169 168zM22278 5363h-2039c-93 0-168-75-168-168s75-168 168-168h2039c93 0 168 75 168 168s-75 168-168 168z"
                    className="fill stroke1"
          style={{
            strokeWidth: 271.494,
            strokeLinecap: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
